import NsSkeleton from '@britishgasenergy/react-nucleus/dist/nuc-components/NsSkeleton';

import { NsDescriptionList } from 'components/common/ns-description-list/NsDescriptionList';

export const testId = 'addressSelectorSkeletonTestId';

type AddressSelectorSkeletonProps = {
  postcode?: string;
};

export const AddressSelectorSkeleton = ({ postcode }: AddressSelectorSkeletonProps) => {
  return (
    <>
      <NsDescriptionList>
        {[
          {
            term: 'Postcode',
            description: postcode
          }
        ]}
      </NsDescriptionList>
      <NsSkeleton data-testid={testId} />
    </>
  );
};
